import { aggregateReportsByH3 } from "./aggregation.js";
import { hexCellsToFeatureCollections } from "./geojson.js";
import { h3ResolutionForZoom } from "./resolution.js";
import { filterHexReportsBySymptoms, hexSymptomSelectionKey } from "./symptoms.js";
import { filterHexReportsByTime } from "./time-series.js";

// Keeps aggregation and source replacement aligned to effective human inputs.
// The map adapter owns Mapbox calls; this module keeps the behavior testable.
export function createHexResolutionRenderer({
  reports,
  setFeatureCollections,
  onResolutionChange = () => {},
  removeActivePopup = () => {},
}) {
  let displayedKey = null;
  let displayedResolution = null;

  return {
    get displayedResolution() {
      return displayedResolution;
    },
    updateForZoom(zoom) {
      return this.update({ zoom });
    },
    update({ zoom, timeState = null, selectedSymptoms = [] }) {
      const resolution = h3ResolutionForZoom(zoom);
      // A cumulative range has two independently adjustable bounds. Include both
      // so moving its left handle replaces the aggregate even when the selected
      // (right-hand) date and H3 resolution have not changed.
      const renderKey = JSON.stringify([
        resolution,
        timeState?.startDate || "all",
        timeState?.selectedDate || "all",
        hexSymptomSelectionKey(selectedSymptoms),
      ]);
      if (renderKey === displayedKey) return false;

      // A feature is no longer valid once its source data changes resolution or filters.
      removeActivePopup();
      const timeFilteredReports = timeState ? filterHexReportsByTime(reports, timeState) : reports;
      const filteredReports = filterHexReportsBySymptoms(timeFilteredReports, selectedSymptoms);
      const cells = aggregateReportsByH3(filteredReports, resolution);
      const collections = hexCellsToFeatureCollections(cells, { resolution });
      setFeatureCollections(collections, resolution);
      const resolutionChanged = resolution !== displayedResolution;
      displayedKey = renderKey;
      displayedResolution = resolution;
      if (resolutionChanged) onResolutionChange(resolution);
      return true;
    },
  };
}
